export const getStoryboardType = (name) => {
  switch (name) {
    case 'LANDING_PAGE':
      return 'Landing Page';
    case 'INTERACTIVE_CONTENT':
      return 'Interactive Content';
    case 'RESOURCE_CENTER':
      return 'Resource Center';
    case 'SPATIAL':
      return 'Spatial';
    default:
      return name;
  }
};

export const getStoryboardMixpanelEventPayload = (id, name, type) => {
  if(id && name && type){
    return {
      'storyboard_id': id,
      'storyboard_name': name,
      'storyboard_content_type': getStoryboardType(type),
    }
  }else {
    return {}
  }
}

export const getPageViewedEventPayload = (screen_name, id, name, type) => {
  const basePayload = {
    screen_name: screen_name,
  };

  return id && name && type
    ? {
        ...basePayload,
        storyboard_id: id,
        storyboard_name: name,
        storyboard_content_type: getStoryboardType(type),
      }
    : basePayload;
};

  
  export const getCustomFieldType = (name) => {
    switch (name) {
      case 'list_field':
        return 'List';
      case 'string_field':
        return 'Text';
      case 'number_field':
        return 'Number';
      case 'boolean_field':
        return 'Decision Box';
      default:
        return name;
    }
  }
